import React from 'react';
import SectionChip from '../components/SectionChip';
import { Tooltip } from '../components/ui/Tooltip';

export interface BoxLocationSource {
  location_name: string | null;
  section_code?: string | null;
  area_name?: string | null;
  warehouse_name?: string | null;
  location_path?: string;
}

/** Where a box sits: the section chip then the area and warehouse, or the plain path when it has no section. */
const BoxLocation: React.FC<{ where: BoxLocationSource }> = ({ where: w }) => {
  if (w.section_code) {
    const rest = [w.area_name, w.warehouse_name].filter(Boolean).join(', ');
    return (
      <Tooltip label={w.location_path || ''}>
        <span className="inline-flex items-center gap-2">
          <SectionChip code={w.section_code} />
          {rest && <span>{rest}</span>}
        </span>
      </Tooltip>
    );
  }
  return <>{w.location_path || w.location_name || '—'}</>;
};

export default BoxLocation;
